var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"grey lighten-3"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-sheet',{attrs:{"min-height":"70vh","rounded":"lg"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }